import Swiper, { Pagination } from 'swiper';

const SwiperProducts = function () {
  
  // configure Swiper to use modules
  Swiper.use( Pagination );
  const els = document.querySelectorAll( '.swiper-products' );

  // loop through swiper sections and init Swiper
  if ( Object.keys(els).length ) {
    els.forEach( function( el ){
      const pagination = el.querySelector( '.swiper-pagination');
      const swiper = new Swiper( el , {
        direction: 'horizontal',
        spaceBetween: 15,
        slidesPerView: 1,
        centeredSlides: true,
        initialSlide: 0,
        loop: false,
        preventClicks: true,
        pagination: {
          el: pagination,
          clickable: true
        },
        breakpoints: {
          992: {
            slidesPerView: 'auto',
            centeredSlides: false,
            pagination: false
          }
        }
      })
    });
  }

}

export default SwiperProducts;